import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Overlay from 'components/Overlay/Overlay';
import { toggleModal } from 'actions/modalActions';
import * as baseStateActions from 'actions/baseStateActions';
import calendarUtils from 'utils/calendar';

import config from 'config/global';
import { range } from 'utils/utils';

import './RoomOptionsLayout.scss';

/* istanbul ignore next */
const mapStateToProps = state => ({
  appState: state.appState,
  baseState: state.baseState,
});

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    baseStateActionsBound: bindActionCreators(baseStateActions, dispatch),
    toggleModalBound: () => dispatch(toggleModal('')),
  };
}

export class RoomOptionsLayout extends Component {
  static propTypes = {
    appState: ImmutablePropTypes.map,
    baseState: ImmutablePropTypes.map,
    baseStateActionsBound: PropTypes.shape({
      loadBaseState: PropTypes.func.isRequired,
    }).isRequired,
    toggleModalBound: PropTypes.func.isRequired,
  };

  static defaultProps = {
    appState: Immutable.Map(),
    baseState: Immutable.Map(),
  };

  state = {};

  componentWillMount() {
    const rooms = this.getRoomsFromBaseState();
    this.setState({ rooms });
  }

  getRoomsFromBaseState() {
    const { baseState } = this.props;
    return baseState.getIn(['queryState', 'props', 'rooms'], Immutable.List());
  }

  onApplyClick = (event) => {
    const {
      baseState,
      baseStateActionsBound,
      toggleModalBound,
    } = this.props;

    const calDate = calendarUtils.getDepartureDate(baseState, true);
    const originalNumberOfRooms = this.getRoomsFromBaseState().size;
    const newRooms = this.state.rooms;
    const newNumberOfRooms = newRooms.size;

    const baseStateRequest = {
      calDate,
      state: baseState.get('currentStateEncoded'),
    };

    newRooms.forEach((room, index) => {
      const numberOfAdults = newRooms.getIn([index, 'nAdt', 'value']);
      const childAges = newRooms.getIn([index, 'cdn', 'arrayValue'], Immutable.List()).join(',');
      baseStateRequest[`rooms[${index}].nAdt`] = numberOfAdults;
      baseStateRequest[`rooms[${index}].cdn`] = childAges;
    });

    if (newNumberOfRooms < originalNumberOfRooms) {
      range(newNumberOfRooms, originalNumberOfRooms).forEach((room, index) => {
        baseStateRequest[`rooms[${index + newNumberOfRooms}]`] = 'removed';
      });
    }

    baseStateActionsBound.loadBaseState(baseStateRequest).then(() => {
      toggleModalBound(event);
    });
  }

  onCancelClick = (event) => {
    this.props.toggleModalBound(event);
  }

  onNumberOfAdultsChange = roomIndex => (event) => {
    const value = event.currentTarget.value;
    const rooms = this.state.rooms.setIn([roomIndex, 'nAdt', 'value'], Number(value));
    this.setState({ rooms });
  }

  onNumberOfChildrenChange = roomIndex => (event) => {
    const value = Number(event.currentTarget.value);
    let childAges = this.state.rooms.getIn([roomIndex, 'cdn', 'arrayValue'], Immutable.List());
    const numberOfChildren = childAges.size;

    if (numberOfChildren > value) {
      childAges = childAges.slice(0, value);
    } else if (numberOfChildren < value) {
      const newChildren = new Array(value - numberOfChildren).fill('tbc');
      childAges = Immutable.fromJS([...childAges.toJS(), ...newChildren]);
    }

    const rooms = this.state.rooms.setIn([roomIndex, 'cdn', 'arrayValue'], childAges);
    this.setState({ rooms });
  }

  onChildAgeChange = (roomIndex, childAgeIndex) => (event) => {
    const value = event.currentTarget.value;
    const rooms = this.state.rooms.setIn([roomIndex, 'cdn', 'arrayValue', childAgeIndex], value);
    this.setState({ rooms });
  }

  onRemoveRoomClick = roomIndex => () => {
    const rooms = this.state.rooms.filter((room, index) => index !== roomIndex);
    this.setState({ rooms });
  }

  onAddRoomClick = () => {
    const newRoom = Immutable.fromJS({
      cdn: {
        arrayValue: [],
      },
      nAdt: {
        value: 2,
      },
    });

    const rooms = this.state.rooms.push(newRoom);
    this.setState({ rooms });
  }

  render() {
    const {
      appState,
    } = this.props;

    const isLoading = appState.get('loadingState');

    const rooms = this.state.rooms;

    let errorInParty = false;

    return (
      <div className="room-options-layout">
        <h3 className="room-options-layout__title">Specify Party Size</h3>

        { isLoading && <Overlay loadingState={isLoading} /> }

        <div className="room-options-layout__rooms">
          { rooms.map((room, roomIndex) => {
            const adultsCount = room.getIn(['nAdt', 'value'], 0);
            const childAges = room.getIn(['cdn', 'arrayValue'], Immutable.List());

            const isErrorWithRoom = childAges.some(age => age === 'tbc');
            const isTooManyPeopleInRoom = (adultsCount + childAges.size) > 5;

            if (isErrorWithRoom || isTooManyPeopleInRoom) {
              errorInParty = true;
            }

            return (
              <div className="room-options-layout__room__wrapper" key={roomIndex}>

                <div className="room-options-layout__room__selects">


                  <div className="room-options-layout__room__section__people">
                    <div className="room-options-layout__room__title">
                      <b>Room {roomIndex + 1}</b>
                    </div>

                    <label className="room-options-layout__room__adults">
                      <span className="room-options-layout__room__adults__label">
                        Adults:
                      </span>
                      <select
                        className="room-options-layout__room__adults__select"
                        onChange={this.onNumberOfAdultsChange(roomIndex)}
                        value={Number(adultsCount)}
                      >
                        { config.adultsOptions.map((numAdults, i) =>
                          <option value={numAdults} key={i}>{numAdults}</option>,
                        )}
                      </select>
                    </label>

                    <label className="room-options-layout__room__children">
                      <span className="room-options-layout__room__children__label">
                        Children:
                      </span>
                      <select
                        className="room-options-layout__room__children__select"
                        onChange={this.onNumberOfChildrenChange(roomIndex)}
                        value={childAges.size}
                      >
                        { config.childrenOptions.map((numChildren, i) =>
                          <option value={numChildren} key={i}>{numChildren}</option>,
                        )}
                      </select>
                    </label>
                  </div>

                  { !!childAges.size && (
                    <div className="room-options-layout__room__section__ages">
                      <div className="room-options-layout__room__title"><b>Child Ages</b></div>
                      { childAges.map((childAge, childAgeIndex) => {
                        const isErrorWithAge = childAge === 'tbc';

                        return (
                          <label className="room-options-layout__room__children-age" key={childAgeIndex}>
                            <span className="room-options-layout__room__children__label">
                              Child {childAgeIndex + 1}:
                            </span>
                            <select
                              className={`room-options-layout__room__children-age__select ${isErrorWithAge ? 'room-options-layout__children-age__room__select--error' : ''}`}
                              value={childAge}
                              onChange={this.onChildAgeChange(roomIndex, childAgeIndex)}
                            >
                              <option value="tbc" />
                              { range(0, config.maxChildAge + 1).map((age, ageIndex) =>
                                <option value={`${age}`} key={ageIndex}>{age}</option>,
                              )}
                            </select>
                          </label>
                        );
                      })}
                    </div>
                  )}
                </div>

                { rooms.size > 1 && (
                  <button
                    onClick={this.onRemoveRoomClick(roomIndex)}
                    className="room-options-layout__room__remove"
                  >
                    - Remove room
                  </button>
                )}

                { isErrorWithRoom && (
                  <div className="room-options-layout__error">
                    Please ensure all the children have an age.
                  </div>
                )}

                { isTooManyPeopleInRoom && (
                  <div className="room-options-layout__error">
                    The maximum number of people allowed in this room is 5.
                  </div>
                )}

              </div>
            );
          })}

          { rooms.size < 3 && (
            <div className="room-options-layout__button-group">
              <button
                onClick={this.onAddRoomClick}
                className="room-options-layout__room__add"
              >
                + Add another room
              </button>
            </div>
          )}

          <div className="room-options-layout__button-group">
            <button
              onClick={this.onCancelClick}
              className="room-options-layout__button room-options-layout__button--cancel"
            >
              Cancel
            </button>

            <button
              onClick={this.onApplyClick}
              className={`room-options-layout__button room-options-layout__button--apply ${errorInParty ? 'room-options-layout__button--disabled' : ''}`}
              disabled={errorInParty}
            >
              Apply
            </button>
          </div>

        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RoomOptionsLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/RoomOptionsLayout/RoomOptionsLayout.jsx
 **/